import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons-general/icon-close-cross-grey.svg'
import _imports_1 from '@/assets/icons-general/icon-back.svg'


import { toRefs } from 'vue'

interface EMITS {
  (e: 'closeOverlay')
  (e: 'resetAll')
  (e: 'goBack')
}
interface PROPS {
  leftBox: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ListMenuHeader',
  props: {
    leftBox: { type: Boolean }
  },
  emits: ["closeOverlay", "resetAll", "goBack"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props
const { leftBox } = toRefs(props)

function closeOverlay() {
  emits('closeOverlay')
}

function resetAll() {
  emits('resetAll')
}
function goBack() {
  emits('goBack')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(leftBox))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "back-box",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeOverlay()))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("img", {
            class: "go-back-img",
            src: _imports_0
          }, null, -1)
        ])))
      : _createCommentVNode("", true),
    (!_unref(leftBox))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "back-box",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goBack()))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("img", {
            class: "go-back-img",
            src: _imports_1
          }, null, -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "reset-button-style-mobile",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (resetAll()))
    }, _toDisplayString(_ctx.$t('general__data__reset-all-choices')), 1)
  ], 64))
}
}

})